// extracted by mini-css-extract-plugin
module.exports = {"image":"cM","image-placeholder":"cN","imagePlaceholder":"cN"};